// extracted by mini-css-extract-plugin
export default {"proteinRender":"protein_render_proteinRender__JXx-E"};